import { TextField, Button, Stack, Box, FormControl, Select, InputLabel, MenuItem, Tooltip } from "@mui/material";
import { useState } from "react";
export default function PvCreateForm() {
    const [lang, setLang] = useState('pl');
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [link, setLink] = useState('wait for it');
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const handleSubmit = (e) => {
        console.log(name, surname, lang);


        const headers = { "Content-Type": "application/x-www-form-urlencoded" };
        const body = new URLSearchParams({
            "grant_type": "password",
            "username": username,
            "password": password,
        })

        fetch(`${process.env.REACT_APP_PV_API_URL}/token`, {
            method: 'POST',
            headers,
            body,
        })
            .then(tokenRes => tokenRes.json())
            .then(token => {
                console.log(token);
                fetch(`${process.env.REACT_APP_PV_API_URL}/pv_session/`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token.access_token}`,
                        'Content-Type': 'application/json'
                    }
                }
                )
                    .then(res => res.json())
                    .then(res => {
                        console.log(res);
                        setLink(`${window.location.origin}?pv_uuid=${res.pv_uuid}&lang=${lang}`);
                        fetch(`${process.env.REACT_APP_PV_API_URL}/pv_session/${res.pv_uuid}/client?first_name=${name}&surname=${surname}`, {
                            method: 'POST',
                            headers: {
                                'Authorization': `Bearer ${token.access_token}`,
                                'Content-Type': 'application/json'
                            }
                        })

                            .then(res => res.json())
                            .then(res => {
                                console.log(res);
                            })

                    })



            })


    }

    return (
        <Box
            sx={{
                mt: 3,
                textAlign: 'left',
            }}
            justifyContent="center"
            alignItems="center"

        >
            <Stack
                maxWidth="800px"
                spacing={3}
                sx={{
                    mx: 'auto',
                }}
            >
                <TextField label="Username" variant="outlined" value={username} onChange={(e) => setUsername(e.target.value)} />
                <TextField type="password" label="Password" variant="outlined" value={password} onChange={(e) => setPassword(e.target.value)} />
                <TextField label="Name" variant="outlined" value={name} onChange={(e) => setName(e.target.value)} />
                <TextField label="Surname" variant="outlined" value={surname} onChange={(e) => setSurname(e.target.value)} />
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Language</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={lang}
                        label="Language"
                        onChange={(e) => setLang(e.target.value)}
                    >
                        <MenuItem value="pl">Polish</MenuItem>
                        <MenuItem value="en">English</MenuItem>
                        <MenuItem value="it">Italian</MenuItem>
                        <MenuItem value="ua">Ukrainian</MenuItem>

                    </Select>
                </FormControl>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    size="large"
                >
                    Generate link
                </Button>
                <Tooltip title="Link copied to clipboard" followCursor open={tooltipOpen}>
                    <TextField
                        label="Link"
                        variant="outlined"
                        value={link}
                        onClick={() => {
                            navigator.clipboard.writeText(link)
                            setTooltipOpen(true)
                            setTimeout(() => {
                                setTooltipOpen(false)
                            }, 2000)

                        }}

                    />
                </Tooltip>
            </Stack>
        </Box>
    );
}